import axiosConfig from "./axiosConfig";

export interface HardwareDevice {
  hardware_type: "inverter" | "epm" | "meter" | "battery";
  serial_number: string;
  meter_type?: "grid" | "pv" | "battery";
  device_name?: string;
}

export interface SiteIngestionConfig {
  site_id: string;
  site_name: string;
  esys_uuid: string;
  data_source_type: "solis" | "solaredge" | "reduxi";
  soracom_imsi?: string;
  has_monitoring_config?: boolean;
  created_at?: string;
  updated_at?: string;
  solis_site_id?: string;
  solis_devices?: Record<string, HardwareDevice>;
  reduxi_controller_id?: string;
  reduxi_devices?: Record<string, HardwareDevice>;
  iot_policy_restricted?: boolean;
  solaredge_api_key?: string;
  solaredge_site_id?: string;
  solaredge_timezone?: string;
  isolarcloud_link?: string;
  earliest_raw_data_date?: string;
}

export interface SiteIngestionResponse {
  site: SiteIngestionConfig;
}

const getSiteIngestion = async (
  authToken: string,
  siteId: string,
  esysUuid: string
): Promise<SiteIngestionResponse | null> => {
  const { data } = await axiosConfig.get(`/site/${siteId}/ingestion`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    params: { esysUuid },
  });
  // BMA returns `{site: null}` (200) when the site has no ingestion config —
  // a legitimate state, not an error. Normalise to null for callers.
  if (data == null || data.site == null) {
    return null;
  }
  return data;
};

export default getSiteIngestion;
